import isObject from 'lodash/isObject'
import { normalize } from '../../utils/hydra'
import SubmissionError from '../../error/SubmissionError'

const MIME_TYPE = 'application/ld+json'
export const CORE_API_HOST = process.env.VUE_APP_CORE_API_HOST

const makeParamArray = (key, arr) => arr.map(val => `${key}[]=${val}`).join('&')

export default {
  /**
   * USAIL Security Plugin
   * @param Vue
   * @returns {*|boolean|[]|void|boolean}
   */
  install(Vue) {
    Vue.prototype.$api = {
      fetch(id, options = {}) {
        if ('undefined' === typeof options.headers) {
          options.headers = {}
        }

        if (!Object.prototype.hasOwnProperty.call(options.headers, 'Authorization')) {
          options.headers = { ...options.headers, Authorization: 'Bearer ' + Vue.keycloak.token }
        }

        if (!Object.prototype.hasOwnProperty.call(options.headers, 'Accept')) {
          options.headers = { ...options.headers, Accept: MIME_TYPE }
        }

        if (
          undefined !== options.body &&
          !(options.body instanceof FormData) &&
          !Object.prototype.hasOwnProperty.call(options.headers, 'Content-Type')
        ) {
          options.headers = { ...options.headers, 'Content-Type': MIME_TYPE }
        }

        if (options.params) {
          const params = normalize(options.params)
          let queryString = Object.keys(params)
            .map(key => (Array.isArray(params[key]) ? makeParamArray(key, params[key]) : `${key}=${params[key]}`))
            .join('&')
          id = `${id}?${queryString}`
        }

        const entryPoint = CORE_API_HOST + (CORE_API_HOST.endsWith('/') ? '' : '/')

        const payload = !(options.body instanceof FormData) && options.body && JSON.parse(options.body)
        if (isObject(payload) && payload['@id']) options.body = JSON.stringify(normalize(payload))

        return Vue.keycloak
          .updateToken(30)
          .then(() => {
            return global.fetch(new URL(id, entryPoint), options).then(response => {
              if (response.ok) return response

              if (401 === response.status) {
                response.text().then(body => {
                  if (body.indexOf('Invalid access token') !== -1 || body.indexOf('Invalid credentials') !== -1) {
                    // eslint-disable-next-line no-console
                    console.log('Invalid credentials')
                    Vue.keycloak.login({
                      redirectUri: window.origin + '/auth-callback'
                    })
                  }
                })

                return
              }

              return response.json().then(
                json => {
                  const error = json['hydra:description'] || json['hydra:title'] || 'An error occurred.'

                  if (!json.violations) throw Error(error)

                  let errors = { _error: error }
                  json.violations.forEach(violation =>
                    errors[violation.propertyPath]
                      ? (errors[violation.propertyPath] += '\n' + errors[violation.propertyPath])
                      : (errors[violation.propertyPath] = violation.message)
                  )

                  throw new SubmissionError(errors)
                },
                () => {
                  throw new Error(response.statusText || 'An error occurred.')
                }
              )
            })
          })
          .catch(e => {
            if ('Forbidden' === e.message) {
              // eslint-disable-next-line no-console
              console.log(e)
              Vue.keycloak.login({
                redirectUri: window.origin + '/auth-callback'
              })
            } else {
              throw e
            }
          })
      },
      makeService(endpoint) {
        const _this = this
        return {
          find(id) {
            return _this.fetch(`${id}`)
          },
          findAll(params) {
            return _this.fetch(endpoint, params)
          },
          create(payload) {
            return _this.fetch(endpoint, { method: 'POST', body: JSON.stringify(payload) })
          },
          del(item) {
            return _this.fetch(item['@id'], { method: 'DELETE' })
          },
          update(payload) {
            return _this.fetch(payload['@id'], {
              method: 'PUT',
              body: JSON.stringify(payload)
            })
          }
        }
      }
    }
    Vue.api = Vue.prototype.$api
  }
}
